import { render, staticRenderFns } from "./DashboardHistory.vue?vue&type=template&id=709dcabb"
import script from "./DashboardHistory.vue?vue&type=script&lang=js"
export * from "./DashboardHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports